import { get } from "lodash";

export const getUnitById = (unitId, unitsById) =>
	get(unitsById, `${unitId}`, null);

export const getUnitsById = (unitIds, unitsById) =>
	unitIds.map((i) => getUnitById(i, unitsById));

export const getUnitPrices = (unit) => ({
	lowestPrice: unit.price.sparefoot || unit.price.regular,
	startingPrice: unit.price.regular
})

export const getUnitCardProps = (unit) => {
	const {
		facilityId,
		id,
		url,
		sizeText,
		unitType,
		typeText,
		availableAmenities,
		special,
		reservationWindow,
		quantity,
		tierName,
		tierDescription,
		tierRank,
		squareFootage,
	} = unit;

	return {
		id,
		facilityId,
		url,
		sizeText,
		unitType,
		typeText,
		availableAmenities,
		special,
		reservationWindow,
		quantity,
		tierName,
		tierDescription,
		tierRank,
		squareFootage,
		...getUnitPrices(unit)
	};
};

export const getNearbyUnitCardProps = (unit, facilitiesById) => {
	const { id, sizeText, facilityId } = unit;
	return {
		id,
		url: facilitiesById[facilityId]?.url,
		sizeText,
		...getUnitPrices(unit)
	}
}

export const getUniqueNearbyUnits = (nearbyFacilityUnits, units) => {
	// nearbyFacilityUnits is an array of facility.unit objects
	// these are the possible keys we want to pull from the facility.unit objects
	const unitSizeKeys = ['smallUnit', 'mediumUnit', 'largeUnit'];

	return unitSizeKeys.map(unitSizeKey => {
		let minNearbyUnitSizePrice = Number.POSITIVE_INFINITY
		let minPricedUnit = null;
		nearbyFacilityUnits.forEach(nearbyUnitId => {
			// if the size key doesn't exist for this facility, skip it
			if (!nearbyUnitId[unitSizeKey]) return;
			const { sparefoot, regular } = units[nearbyUnitId[unitSizeKey]]?.price
			const lowestPrice = sparefoot || regular;
			if (lowestPrice < minNearbyUnitSizePrice) {
				minNearbyUnitSizePrice = lowestPrice
				minPricedUnit = units[nearbyUnitId[unitSizeKey]]
			}
		})
		return minPricedUnit;
	}).filter(unit => unit !== null);
}